export const NEXT_PAGE_TOKEN = {
  key: 'nextPageToken',
  responseHeader: 'x-rune-next-page-token',
  requestHeader: 'next_page_token',
}

export const INITIAL_REVISION_NUMBER = 0
export const REVISION_INCREMENT = 1
